import React , {useState ,useEffect}from 'react';
import {Modal, Grid ,Image, Button } from "semantic-ui-react"
import { useMutation } from '@apollo/client';
import {ADD_PUBLIC , PUBLIC_COMPLET } from '../../../gql/publication';
//import estilos from './Slider.module.css';
import "./Slider.scss";

function Slider(props) {
    const { show,setShow, getPublicate,id}= props;
	const onClose = () => setShow (false);
	//const [count, setCount] = useState(parseInt(getPublicate[0].count) + 1 )
	const [completPublic] = useMutation (PUBLIC_COMPLET);
	//const [coun, setCoun] = useState(onSu )

   
   //parseInt("10") + "<br>" +(getPublicate[0].count);
	//setCount(+ 1);

	/*useEffect(() => {
		 console.log ("hola ")

		    
			console.log ("hi")
	
			//console.log (completPublic)
				try {
					 completPublic({
						variables:{	input:{
							idPublication:id,
							count:getPublicate[0].count+1
						}},
	
							 
					});
					
					
				} catch (error) {
					console.log (error);
					
				}
	  
	}, [])
	

*/
		  
	


//console.log(count)
   let imagenes = ([getPublicate[0].file , getPublicate[0].file2, getPublicate[0].file3, getPublicate[0].file4,getPublicate[0].file5,getPublicate[0].file6,getPublicate[0].file7,getPublicate[0].file8,])

	//console.log (imagenes)

	// Variables y Estados
	const [imagenActual, setImagenActual] =useState(0);
	const cantidad = imagenes?.length;
	//console.log (cantidad )

	// Return prematuro para evitar errores
	if (!Array.isArray(imagenes) || cantidad === 0) return;

	const siguienteImagen = () => {
		setImagenActual(imagenActual ===  cantidad - 1 ? 0 : imagenActual + 1);
	};

	//console.log (imagenActual)

	const anteriorImagen = () => {
		setImagenActual(imagenActual === 0 ? cantidad - 1 : imagenActual - 1);
	};

	return (
		<Modal open={show} onClose={onClose} className="modal_foto" computer={8} mobile={16}   >

		<div className= "cont" mobile={16} computer={8}>
			
			{imagenes.map((imagen, index) => {
				
				return (
					<div
						className={
							imagenActual === index
								? `${"slide"} ${"active"}`
								: "slide"
						}>
						{imagenActual === index && (
							<Image key={index} src={imagen}  />
						)}
					</div>
				);
			})} 
			
		</div>

		<div className='botom'>
			<button class="ui orange left labeled icon button" onClick={anteriorImagen} >  <i class="left arrow icon"></i> Anterior</button>
			<button class="ui teal right labeled icon button" onClick={siguienteImagen} > <i class="right arrow icon"></i>Siguiente </button>
			</div>
		</Modal>
	);
}

export default Slider;